import {Box, Breadcrumbs, Chip, Typography} from '@mui/material';
import {SessionQuestion} from '@cp/model';

export interface SessionQuestionHeadProps {
  currentQuestion: SessionQuestion;
}

export default function SessionQuestionHead({currentQuestion}: SessionQuestionHeadProps) {
  const topicData = [currentQuestion.moduleTopic.category, currentQuestion.moduleTopic.topic];
  return (
    <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3}}>
      <Breadcrumbs separator="›" aria-label="topic breadcrumb">
        {topicData.map((t) => (
          <Typography key={`QuizQuestionHead-${t}`} variant="body2" color="text.primary">
            {t}
          </Typography>
        ))}
      </Breadcrumbs>
      <Chip
        label={`Difficulty: ${currentQuestion.difficulty || 'N/A'}`}
        color="secondary"
        variant="outlined"
        size="small"
        sx={{ml: 2}}
      />
    </Box>
  );
}
